// 📄 components/ui/CheckboxCardGroup.tsx
// Fila de opciones tipo "tarjeta" clickeable completa (checkbox + label),
// extraído de "Registrar Cliente" para reutilizarlo donde haga falta
// seleccionar varias opciones de una lista corta (ver ProyectoForm).
import React from 'react';

export interface CheckboxCardOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

interface CheckboxCardGroupProps {
  options: CheckboxCardOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

export default function CheckboxCardGroup({ options, selected, onChange }: CheckboxCardGroupProps) {
  const toggle = (value: string) => {
    onChange(
      selected.includes(value)
        ? selected.filter(v => v !== value)
        : [...selected, value]
    );
  };

  return (
    <div className="space-y-2">
      {options.map((opt) => (
        <label
          key={opt.value}
          className="flex items-center gap-3 p-3 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 hover:border-white/20 cursor-pointer transition-all"
        >
          <input
            type="checkbox"
            className="accent-blue-500 w-4 h-4"
            checked={selected.includes(opt.value)}
            onChange={() => toggle(opt.value)}
          />
          {opt.icon && <span className="text-base">{opt.icon}</span>}
          <span className="text-sm">{opt.label}</span>
        </label>
      ))}
    </div>
  );
}
